import React from 'react';

import { observer, inject } from "mobx-react";
import { Modal as ModalComponent, LeftMenu as LeftMenuComponent, Spinner as SpinnerComponent, AuthMenu as MenuComponent, Messages as MessagesComponent } from '@sogei/react-web-components-catalog'
import { PATH_PORTALE} from '../config/portale-config';
import { configureHeader, configureFooter, AgenziaAuthHeader, AgenziaAuthFooter } from '@sogei/agenzia-entrate-common'


const title = "Request for ID "
const subtitle = ""

const organization = {
  name: 'Agenzia delle Entrate',
  url: 'https://www.agenziaentrate.gov.it'
}

const buttonList = [
  {
    url: "https://www.agenziaentrate.gov.it",
    icon: "fas fa-info",
    title: "Info e Assistenza"
  },
  {
    url: `${ process.env.CONTEXT_PATH }/home`,
    icon: "fas fa-sign-out-alt fa-rotate-270",
    title: "Home"
  }
]

const ModalBody = ({ selectedNews }) => <>
  {selectedNews.dataScadenza}

  <div dangerouslySetInnerHTML={{ __html: selectedNews.testo }}></div>

  {selectedNews.error ?
    <div className="alert alert-danger d-flex" role="alert">
      <p className="alert-content"> {selectedNews.error}</p>
    </div>
    : null
  }
</>
const Modal = inject(({ rootStore }) => {
  return {
    data: {
      title: rootStore.homeStore.selectedNews.titolo,
      body: <ModalBody selectedNews={rootStore.homeStore.selectedNews}></ModalBody>
    }
  }
})
(ModalComponent)


/* const AuthHeader = inject(({ rootStore }) => configureHeader(rootStore, title, subtitle, organization, buttonList))(AgenziaAuthHeader) */
const AuthFooter = inject(() => configureFooter(title))(AgenziaAuthFooter)

const AuthMenu = inject(({ rootStore }) => ({
  menuItems: rootStore.menuStore.menuItems,
  location: rootStore.routingStore.location,
/*   context: process.env.CONTEXT_PATH, */
  fetchMenuItems: () => null
}))(MenuComponent)

const LeftMenu = inject(({ rootStore }) => ({
 /*  context: process.env.CONTEXT_PATH, */
  leftMenuItems: rootStore.leftMenuStore.menuItems,
  label: rootStore.leftMenuStore.label,
  location: rootStore.routingStore.location,
  fetchLeftMenuItems: () => rootStore.leftMenuStore.fetchLeftMenu()
}))(LeftMenuComponent)

const Messages = inject(({ rootStore }) => ({
  successMessages: rootStore.uiStore.successMessages,
  infoMessages: rootStore.uiStore.infoMessages,
  warningMessages: rootStore.uiStore.warningMessages,
  dangerMessages: rootStore.uiStore.dangerMessages,
  messagesCount: rootStore.uiStore.messagesCount
}))(MessagesComponent)

const Spinner = inject(({ rootStore }) => ({ isLoading: rootStore.uiStore.isLoading }))(observer(SpinnerComponent))

export {Modal, Spinner, Messages, AuthFooter, AuthMenu, LeftMenu }